<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('destinataries')"
      :columns="columns"
      :column_search="false"
      resource_url="/account-request/destinatary/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="manage_types">
          <span class="icon"><i class="fa fa-cogs"></i></span>
          <span>{{ $t("destinatary types") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar -->
    <destinatary-modal ref="destinatary_modal" @success="refresh_datatable" />
    <view-modal ref="view_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import DestinataryModal from "./destinatary_modal/Index.vue";
import ViewModal from "./view_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  format_date_time,
  error_message,
} from "@/utils";

export default {
  name: "AccountRequestDataTable",
  components: {
    GenericTable,
    DestinataryModal,
    ViewModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("renap data"),
          data: (row) => {
            if (row.renap_data) {
              let r = "";
              return `<div class="title is-6"><span class="icon"><i class="fa fa-user"></i></span><span class="has-text-primary">${
                row.renap_data.PRIMER_NOMBRE || ""
              } ${row.renap_data.PRIMER_APELLIDO || ""}</span></div>
              <div class="subtitle is-6 mb-0"><span class="icon has-text-success"><i class="fa fa-calendar"></i></span><span>${
                row.renap_data.FECHA_NACIMIENTO || "-"
              }</span></div>
              <div class="subtitle is-6"><span class="icon has-text-danger"><i class="fa fa-calendar"></i></span><span>${
                row.renap_data.FECHA_VENCIMIENTO || "-"
              }</span></div>`;
            } else {
              return `<span class="tag is-danger">${this.$t(
                "not available"
              )}</span>`;
            }
          },
        },
        {
          title: this.$t("personal information"),
          data: (row) =>
            `<div class="title is-6"><span class="icon"><i class="fa fa-id-card"></i></span><span>${
              row.dpi || "-"
            }</span></div>
            <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-envelope"></i></span><span>${
              row.email || "-"
            }</span></div>
            <div class="subtitle is-6"><span class="icon"><i class="fa fa-phone"></i></span><span>${
              row.phone || "-"
            }</span></div>`,
        },
        // {
        //   title: this.$t("data"),
        //   data: (row) => `<pre>${JSON.stringify(row, null, 2)}</pre>`,
        // },
        {
          title: this.$t("actions"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  this.edit(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  this.view(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("update renap data"),
                icon: "fa fa-id-card",
                icon_class: "is-small",
                click: (e) => {
                  this.renap(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("update sat data"),
                icon: "fa fa-building",
                icon_class: "is-small",
                click: (e) => {
                  this.sat(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: this.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  this.delete(row);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.destinatary_modal.show_modal();
    },
    edit(row) {
      this.$refs.destinatary_modal.show_modal(row.uuid);
    },
    delete(row) {
      let v = this;
      v.$root.loader(true);
      confirm_deletion_dialog(
        v.$t("are you sure to delete destinatary?"),
        v,
        () => {
          del("/account-request/destinatary", { uuid: row.uuid })
            .then(() => {
              v.refresh_datatable();
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
    manage_types() {
      this.$router.push({ path: "/account-request/destinatary/types" });
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
    view(row) {
      let v = this;
      v.$refs.view_modal.show(row.uuid);
    },
    renap(row) {
      let v = this;
      v.$root.loader(true);
      post("/account-request/destinatary/renap", { uuid: row.uuid })
        .then(() => {
          v.refresh_datatable();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    sat(row) {
      let v = this;
      v.$root.loader(true);
      post("/account-request/destinatary/sat", { uuid: row.uuid })
        .then(() => {
          v.refresh_datatable();
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
